import { hasProductPackages } from '@/lib/package-utils'
import { Button } from '@/components/ui/button'
import {
  useCountry,
  DropdownCountryCombined,
} from '@/components/DropdownCountry'
import { DropdownPid2, DropdownPid3, usePid2 } from '@/components/DropdownPid'
import { MyDatePicker, useDatePicker } from '@/components/MyDatePicker'
import { blobFetcher } from '@/hooks'
import useSWRMutation from 'swr/mutation'
import DataTable from './DataTable'
import DropdownPackageName, {
  usePackageName,
} from '@/components/DropdownPackage'
import ContrastModeSelector from '@/components/roi/ContrastModeSelector'

const Home = () => {
  const pids = usePid2((state) => state.pids)
  const pid = pids.join(',') === '' ? 'total' : pids.join(',')
  // 按产品声明显示子包筛选。
  const showPackageFilter = hasProductPackages(pid)

  return (
    <>
      <div className="flex items-center gap-4 flex-wrap sm:gap-2 sm:py-2 xs:py-1 xs:gap-1">
        <DropdownPid2 />
        <DropdownPid3 />
        {showPackageFilter && <DropdownPackageName />}
        <DropdownCountryCombined />
        <MyDatePicker getMaxDate="complete" showMaxDate={true} />
        <DownloadButton />
      </div>
      <DataTable />
    </>
  )
}
const DownloadButton = () => {
  const startDate = useDatePicker((state) => state.startDate)
  const endDate = useDatePicker((state) => state.endDate)
  const pids = usePid2((state) => state.pids)

  const country = useCountry((state) => state.value)
  const packageName = usePackageName((state) => state.value)

  const { trigger, isMutating } = useSWRMutation(
    ['/reports/roi', { startDate, endDate, pid: pids, country, packageName }],
    blobFetcher,
  )

  const handleDownloadCsv = async () => {
    const { blob, fileName } = await trigger()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName || 'roi_report.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <Button onClick={handleDownloadCsv} variant="outline">
      Download csv{isMutating && 'ing...'}
    </Button>
  )
}

export default Home
